import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { useConfig } from "@/lib/config";

export default function Footer() {
  const cfg = useConfig();
  return (
    <footer className="bg-[#0F172A] text-slate-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#F97316] to-[#EAB308] grid place-items-center text-white font-black font-display">MV</div>
            <div>
              <div className="font-display font-extrabold text-white">Maa Vindhyavasini Packers</div>
              <div className="text-[10px] uppercase tracking-wider text-slate-400">Movers & Transport • Delhi NCR</div>
            </div>
          </div>
          <p className="text-sm">15+ years of safe, insured, on-time relocations across Noida, Gurugram, Ghaziabad, Faridabad & Delhi.</p>
          <p className="text-xs mt-3 text-slate-400">GSTIN: ••AFTPL1206PZW • IBA Approved</p>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Service Cities</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/packers-movers-noida" className="hover:text-[#F97316]">Packers Movers Noida</Link></li>
            <li><Link to="/packers-movers-greater-noida" className="hover:text-[#F97316]">Greater Noida</Link></li>
            <li><Link to="/packers-movers-ghaziabad" className="hover:text-[#F97316]">Ghaziabad</Link></li>
            <li><Link to="/packers-movers-gurugram" className="hover:text-[#F97316]">Gurugram</Link></li>
            <li><Link to="/packers-movers-faridabad" className="hover:text-[#F97316]">Faridabad</Link></li>
            <li><Link to="/packers-movers-delhi" className="hover:text-[#F97316]">Delhi</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services" className="hover:text-[#F97316]">Our Services</Link></li>
            <li><Link to="/about" className="hover:text-[#F97316]">About Us</Link></li>
            <li><Link to="/blog" className="hover:text-[#F97316]">Blog & Tips</Link></li>
            <li><Link to="/contact" className="hover:text-[#F97316]">Get Free Quote</Link></li>
            <li><Link to="/admin/login" className="hover:text-[#F97316] text-slate-500 text-xs">Owner Portal</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-2"><Phone className="w-4 h-4 mt-1 text-[#F97316]" /> +91 80100 41007</li>
            <li className="flex gap-2"><Mail className="w-4 h-4 mt-1 text-[#F97316]" /> mvpackersandmover@gmail.com</li>
            <li className="flex gap-2">
              <MapPin className="w-4 h-4 mt-1 text-[#F97316] flex-none" />
              <span>
                <span className="block"><span className="font-semibold text-white">Head Office:</span> Shop No. 5, Adarsh Market, Harola Main Road, Sector 5, Noida, UP 201301</span>
                <span className="block mt-2"><span className="font-semibold text-white">Branch Office:</span> Shop No. 1, Durga Market, Bhangel Main Road, Noida, UP 201304</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-4 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Maa Vindhyavasini Packers Movers & Transport • mvpackersmovers.in • Made with care in Delhi NCR
      </div>
    </footer>
  );
}
